import { GET_ALL_PRODUCTS_SUCCESS } from "./products.types";

const defaultState = {
  products: []
};

function productsReducer(state = defaultState, action) {
  switch (action.type) {

    case GET_ALL_PRODUCTS_SUCCESS: {
      return { ...state, products: action.payload }; // add your logic here
    }
    default: {
      return state;
    }
  }
}

export default productsReducer;